import React from 'react';
import { useTranslation } from 'react-i18next';

import './DealershipGroupsList.scss';

export type DealershipGroupsListProps = {
  groups: any[];
};

const DealershipGroupsList = ({
  groups,
}: DealershipGroupsListProps) => {
  const { t } = useTranslation();

  return (
    <div className="list-menu">
      {groups.length === 0 && (
        <span className="no-group" data-testid="no-dealership-group">{t('no_dealership_group_assigned')}</span>
      )}
      {groups.length > 0 && (
        <ul>
          {groups.map((group, i) => (
            <li key={i} data-testid={`dealership-group-item-${i + 1}`}>{group.title}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DealershipGroupsList;
